// api
import { fetchApi } from '@/api'
// actions
const inventoryProvidersAll = (context) => {
  let url = 'inventory/providers'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_PROVIDERS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProvidersForm = (context) => {
  let url = 'inventory/providers/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('INVENTORY_PROVIDERS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProvidersShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/providers/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_PROVIDERS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const inventoryProvidersCreate = (context, payload) => {
  let url = 'inventory/providers'
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('INVENTORY_PROVIDERS_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProvidersUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/providers/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('INVENTORY_PROVIDERS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const inventoryProvidersDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/providers/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('INVENTORY_PROVIDERS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  inventoryProvidersAll,
  inventoryProvidersForm,
  inventoryProvidersShow,
  inventoryProvidersCreate,
  inventoryProvidersUpdate,
  inventoryProvidersDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/providers/actions.js